import { areaColorKey, tw } from '../../utils'
import { SubSection } from '../../components/SubSection'
import { TranscriptionScriptPDF } from '../../components/TranscriptionScriptPDF'
import { Image, View } from '@react-pdf/renderer'
import { TitleIcon } from '../../components/TitleIcon'
import { Tips } from '../../components/Tips'
import hearing from '../../assets/hearing--white.png'
import sight from '../../assets/sight.png'
import { FollowRecomendations } from '../../components/FollowRecomendations'
import { useReportPdfContext } from '../../report-pdf-provider'
import { useMemo } from 'react'
import {
  AUDITORY_KEYS,
  AUDITORY_KEY_GUIDELINES,
  OCULAR_KEYS_GUIDELINES,
  getKey,
  getOcularKey,
  getAuditoryKey,
  linksAuditoryAndOcular,
  worksheetsAuditoryAndOcular,
} from './enum'
import { LinkList } from '../../components/LinkList'

export const SecondPage = () => {
  const { data, t, person, type } = useReportPdfContext()
  const areaColor = areaColorKey.orange

  const {
    recommendations: { OCULAR, AUDITORY },
  } = data.results.initialAnalysisList

  const ocular = OCULAR_KEYS_GUIDELINES()[getOcularKey(OCULAR)]
  const auditoryList = AUDITORY_KEY_GUIDELINES(type)[getKey(AUDITORY)]

  const keepInMind = [
    <TranscriptionScriptPDF
      script={'initial-report:sectionEight.linksAndWorkSheet.keepInMind.one'}
    />,
    <TranscriptionScriptPDF
      script={'initial-report:sectionEight.linksAndWorkSheet.keepInMind.two'}
    />,
  ]

  return (
    <>
      <View style={tw('px-12')}>
        <SubSection
          title={t('initial-report:sectionEight.keyGuidelines.title')}
        >
          <View style={tw('flex flex-col gap-6')}>
            <View style={tw('flex flex-col gap-6')}>
              {AUDITORY_KEYS.recAuditoryOcularReferPrimaryCareAuditory ===
              getKey([
                ...(OCULAR ? OCULAR : []),
                ...(AUDITORY ? AUDITORY : []),
              ]) ? (
                <TranscriptionScriptPDF
                  script={
                    'initial-report:sectionEight.keyGuidelines.auditory.rec_auditory_ocular_refer_primary_care_auditory.text'
                  }
                />
              ) : (
                <TranscriptionScriptPDF
                  script={
                    'initial-report:sectionEight.keyGuidelines.auditory.text'
                  }
                />
              )}

              {auditoryList && (
                <TitleIcon
                  title={t(
                    'initial-report:sectionEight.keyGuidelines.auditory.title',
                  )}
                  icon={<Image style={tw('w-8 h-8')} src={hearing} />}
                  areaColor={areaColor}
                />
              )}
              {auditoryList && (
                <View style={tw('flex flex-col gap-6')}>
                  {auditoryList?.map((tip, index) => {
                    return (
                      <Tips
                        areaColor={areaColor}
                        index={index}
                        title={tip.title}
                      >
                        {tip.content}
                      </Tips>
                    )
                  })}
                </View>
              )}
            </View>
            <View style={tw('flex flex-col gap-6')}>
              <TranscriptionScriptPDF
                script={'initial-report:sectionEight.keyGuidelines.ocular.text'}
              />
              <TitleIcon
                title={t(
                  'initial-report:sectionEight.keyGuidelines.ocular.title',
                )}
                icon={<Image style={tw('w-8 h-8')} src={sight} />}
                areaColor={areaColor}
              />
              <View style={tw('flex flex-col gap-6')}>
                {ocular?.map((tip, index) => {
                  return (
                    <Tips areaColor={areaColor} index={index} title={tip.title}>
                      {tip.content}
                    </Tips>
                  )
                })}
              </View>
            </View>
          </View>
        </SubSection>
      </View>
      <FollowRecomendations
        translateFrom="sectionEight.linksAndWorkSheet"
        areaColor={areaColor}
        linksMultipleSections
        linksAndWorkSheetTitle={t(
          `generic.linksAndWorkSheet.title.care`,
        )}
        linksAndWorkSheetText={
          <TranscriptionScriptPDF
            script={`sectionEight.linksAndWorkSheet.text`}
            scriptProps={{ patientName: person.name }}
          />
        }
        links={linksAuditoryAndOcular({
          auditoryKey: AUDITORY[0],
          ocularKey: OCULAR[0],
        })}
        keepInMindList={keepInMind}
        followRecommendationsText={t(
          'sectionEight.linksAndWorkSheet.followRecommendations.text',
        )}
        omsText={t(
          'sectionEight.linksAndWorkSheet.followRecommendations.omsText',
        )}
        workSheetList={worksheetsAuditoryAndOcular({
          auditoryKey: AUDITORY[0],
          ocularKey: OCULAR[0],
        })}
        worksheetId={`worksheet-auditiveAndOcular`}
      />
    </>
  )
}
